<template>
    <div>
        <div class="container">
            <div class="row ">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>

                <div class="col-xl-9">
                    <div class="w-error-page text-center">
                        <h1 class="error-number mb-25">404</h1>
                        <div class="error-title mb-20">ОШИБКА</div>
                        <div class="description mb-10">Упс... Что-то пошло не так</div>
                        <div class="text mb-10">
                            Вы можете посмотреть товары в нашем <br>
                            каталоге или вернуться назад.
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-10 col-lg-8">
                                <div class="row justify-content-center row-buttons">
                                    <div class="col-lg-4 col-sm-6 col-12 col mb-10">
                                        <button @click="goBack" class="button btn-small w-100">Назад</button>
                                    </div>
                                    <div class="col-lg-4 col-sm-6 col-12 col mb-10">
                                        <router-link to="/catalog" class="button btn-small btn-v2 w-100">
                                            В каталог
                                        </router-link>
                                    </div>
                                    <div class="col-12 mb-10">
                                        <router-link to="/" class="homepage__link">
                                            <span class="dashed">На главную</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.setMetaRobots();
    },

    methods: {
        setMetaRobots() {
            document.querySelector('meta[name="robots"]').setAttribute("content", 'noindex');
        },

        goBack() {
            window.history.go(-2);
        }
    }
}
</script>
